$(function() {
  // スマホのときメイン画像をvhで指定してるとアドレスバーの出る出ないで
  // がたつきまくる対策
  var _winWidth;
  var $header;
  var _headerHeight;
  var _winHeight;
  var $kv;
  var _resizeTimer = false;
  var _isSP;
  var _spAdjustFlag = false;
  var _ua = navigator.userAgent;
  if (_ua.indexOf('iPhone') > 0 || _ua.indexOf('iPad') > 0 || _ua.indexOf('Android') > 0 && _ua.indexOf('Mobile') > 0) {
    _isSP = true;
    _spAdjustFlag = true;
  } else {
    _isSP = false;
  }
  //
  var adjustKeyVisual = function() {
    _winWidth = window.innerWidth;
    if (_winWidth <= 1024 && _spAdjustFlag) {
      $header = $('#js-header');
      _headerHeight = $header.outerHeight();
      _winHeight = $(window).height();
      $kv = $('#js-kv');
      $kvHeight = _winHeight - _headerHeight - 20;
      $kv.height($kvHeight);
      _spAdjustFlag = false;
    }
  };
  //
  if (_isSP) {
    adjustKeyVisual();
  }
  //
  window.addEventListener('resize', function() {
    if (_resizeTimer !== false) {
      clearTimeout(_resizeTimer);
    }
    _resizeTimer = setTimeout(function() {
      adjustKeyVisual();
    }, 400);
  }, false);
});
